import Box from "@/components/Box";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { PanelBoxV2 } from "@/tpo/Boxes";

import InviteYourPatientForm from "../forms/InviteYourPatientForm";

export default function InviteYourPatients() {
  const { organisation } = useOrganisationContext();

  return (
    <PanelBoxV2 maxWidth={1280}>
      <PanelBoxV2
        maxWidth={1020}
        outer={{
          pt: [30, 30, 60],
          pb: [50, 50, 80],
          bg: "white",
          px: 20,
          borderRadius: 5,
          "data-component-name": "InviteYourPatients"
        }}
        stacked
        gap={20}
      >
        <Box fontFamily="gilroyBold" fontSize={[28, 28, 36]} lineHeight="130%">
          New patient registration
        </Box>
        <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]} lineHeight="150%">
          Add a patient’s basic details and send them a secure registration request. Once completed,
          they’ll be added to your patient list, ready to select when placing an order.
          <br />
          <br />
          Tick the box below if you’d also like to invite them to the patient platform, where they
          can view results and reports you choose to release.
          <br />
        </Box>
        <Box my={20}>
          <InviteYourPatientForm />
        </Box>
        <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]} lineHeight="150%">
          Or use your unique registration link :{" "}
          <Box as="span" color="anchorBlue" wordWrap="break-word">
            {organisation?.patientRegistrationUrl}
          </Box>
          <br />
          <br />
          Share this link with patients so they can submit their own details directly. Once
          completed, they’ll be added to your patient list, but not invited to the patient platform.
          <br />
          <br />
          You can share the link by email, text, or add it to your own QR code for patients to scan.
          <br />
          <br />
        </Box>
      </PanelBoxV2>
    </PanelBoxV2>
  );
}
